import { useState } from "react";
import { NodeExecutionCondition } from "../../types/workflow";

const useExecutionConditions = () => {
    const [executionConditionsForNodes, setExecutionConditionsForNodes] = useState<Record<string, NodeExecutionCondition[]>>({});

    return {
        executionConditionsForNodes,
        setExecutionConditionsForNodes,
    };
};

export default useExecutionConditions;
